<template>
  <v-card
    class="stat-card"
    :class="`bg-gradient-${gradient}`"
    theme="dark"
    elevation="0"
  >
    <v-card-text class="pa-6">
      <div class="d-flex align-center justify-space-between">
        <div>
          <p class="stat-label">{{ label }}</p>
          <p class="stat-value">{{ value }}</p>
        </div>
        <v-icon size="56" opacity="0.7" :icon="icon"></v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-chart-box-outline",
    },
    gradient: {
      type: String,
      default: "primary",
      validator: (value) =>
        ["primary", "success", "info", "warning", "danger"].includes(value),
    },
  },
};
</script>

<style scoped>
.stat-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 12px !important;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.stat-label {
  font-size: 0.85rem;
  font-weight: 600;
  opacity: 0.9;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}
</style>
